<template>
  <div class="responsive">
    <table class="table">
      <thead class="table__head">
        <slot name="header" />
      </thead>
      <tbody class="table__body">
        <slot name="body" />
      </tbody>
    </table>
  </div>
</template>
<script>
export default {
  props: {
    marked: {
      type: Boolean,
      default: false
    }
  }
};
</script>
<style lang="scss">
@use "@/assets/styles/settings/_variables.scss";
.responsive {
  overflow: auto;
}
.table {
  /* border: none;
    */
  border-radius: variables.$br-box;
  border-style: hidden;
  min-width: 300px;
  border-bottom: 1px solid variables.$primary-color;
  &--collapse {
    border-collapse: collapse;
  }
  &__head {
    tr {
      font-size: variables.$fs-thead;
      background-color: variables.$primary-color;
      color: variables.$text-inverted-color;
      text-align: left;
      th {
        font-weight: 300;
        &:first-of-type {
          border-top-left-radius: variables.$br-box;
        }
        &:last-of-type {
          border-top-right-radius: variables.$br-box;
        }
      }
    }
  }
  th,
  td {
    padding: 12px 15px;
  }
  &__body {
    tr {
      &:nth-of-type(even) {
        background-color: #f8f8f8;
      }
      &:nth-of-type(odd) {
        background-color: #fcfcfc;
      }
      &:last-of-type {
        border-bottom: 2px solid variables.$primary-color;
        td:first-of-type {
          border-bottom-left-radius: variables.$br-box;
        }
        td:last-of-type {
          border-bottom-right-radius: variables.$br-box;
        }
      }
      &:hover {
        background-color: #f2f2f2;
      }
    }
  }
}
</style>
